import { LoadingIndicator } from '@laerdal/life-react-components';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { signInWithAuth0 } from '../../store/slices/userSlice';

const LoadingContainer = styled.div`
  padding: 50px;
`;

const LoginPage = () => {
  const [search] = useSearchParams();

  useEffect(() => {
    const returnUrl = search.get('returnUrl') ?? window.location.origin;
    const email = search.get('email') || search.get('_email') || undefined;
    signInWithAuth0(returnUrl, undefined, email);
  }, []);

  return <LoadingContainer><LoadingIndicator /></LoadingContainer>;
};

export default LoginPage;
